class PolygonYMap {
    constructor(mapEL, center, clickCb, pointOptions) {
        this.mapEL = mapEL;
        this.objectId = null;
        this.mapPointsUrl = mapEL.dataset.urlPoints || '/inc/ajax_map.php?bbox=%b';
        ymaps.ready(this.init.bind(this, mapEL, center, clickCb, pointOptions));
    }

    init(mapEL, center, clickCb, pointOptions) {
        const zoom = this.mapEL.dataset.zoom;

        this.map = new ymaps.Map(mapEL, {
            center,
            zoom: zoom ? +zoom : 9,
            controls: ['zoomControl', 'rulerControl'],
        });

        const options = pointOptions && pointOptions(this);
        //this.addPoint(center, options, clickCb);
        this.addPointsLoader(options, clickCb);

        this.map.events.add('click', () => {
            this.map.balloon.close();
        });

        this.map.events.add('boundschange', (e) => {
            const newZoom = e.get('newZoom');
            const oldZoom = e.get('oldZoom');
            if (newZoom !== oldZoom) {
                document.dispatchEvent(new CustomEvent('map-zoom-change', {
                    detail: {
                        zoom: newZoom,
                        bounds: this.map.getBounds(),
                    },
                }));
            }
        });
    }

    addPoint(center, options, clickCb) {
        const self = this;
        this.point = getMapPont(center, '21 мил', true, options, {
            build() {
                this.constructor.superclass.build.call(this);
                self.pointEl = this.getParentElement();
                if (self.pointEl) {
                    self.pointEl = self.pointEl.querySelector('.MapOnePoint__point');
                }
            },
        });
        this.point.events.add('click', clickCb)
        this.point.events.add('click', () => {
            if (!this.point.balloon.isOpen()) {//Если открываем
                this.point.balloon.autoPan();
            }
        })
        this.map.geoObjects
            .add(this.point)
    }

    addPointsLoader(options = {}, clickCb) {
        this.loadingObjectManager = new ymaps.LoadingObjectManager(this.mapPointsUrl, {
            // Включаем кластеризацию.
            clusterize: true,
            // Зададим опции кластерам.
            // Опции кластеров задаются с префиксом cluster.
            clusterDisableClickZoom: true,
            clusterHasBalloon: false,
            // Опции объектов задаются с префиксом geoObject.
            geoObjectOpenBalloonOnClick: false,
        });

        this.loadingObjectManager.clusters.events.add(['click'], (e) => {
            this.map.balloon.close();
            const cluster = this.loadingObjectManager.clusters.getById(e.get('objectId'));
            const objects = cluster.properties.geoObjects;
            const idsObjects = objects.map(({ properties }) => properties.id);

            document.dispatchEvent(new CustomEvent('map-cluster-click', { detail: idsObjects }));
        });
        this.loadingObjectManager.objects.events.add(['click'], (e) => {
            setMapListObject(false);
            this.setStatePoint(false);
            this.objectId = e.get('objectId');
            const object = this.loadingObjectManager.objects.getById(this.objectId);

            if (!window.$isMobile) {
                this.fetchObject(object.properties, (html) => {
                    this.setProperties('balloonContent', html);
                    this.loadingObjectManager.objects.balloon.open(this.objectId);
                    //point.properties.set('balloonContent', html);

                    clickCb(e, object);
                });
            } else {
                clickCb(e, object);
            }

        });
        this.loadingObjectManager.objects.options.set(getMapPontOptions(true, {
            ...options,
            iconImageHref: undefined,
        }));
        this.loadingObjectManager.clusters.options.set({ preset: 'islands#darkBlueClusterIcons' });

        this.map.geoObjects.add(this.loadingObjectManager);


    }

    getOption(key) {
        if (this.point) {
            return this.point.options.get(key);
        } else {
            const object = this.loadingObjectManager.objects.getById(this.objectId);
            if(object) {
                return object.options[key];
            }
        }
    }

    setOption(key, value) {
        if (this.point) {
            this.point.options.set(key, value);
        } else {
            this.loadingObjectManager.objects.setObjectOptions(this.objectId, {
                [key]: value,
            });
        }
    }

    setProperties(key, value, id = this.objectId) {
        if (this.point) {
            this.point.properties.set(key, value);
        } else {
            this.loadingObjectManager.objects.setObjectProperties(id, {
                [key]: value,
            });
        }
    }

    setStatePoint(state) {
        const id = this.point ? this.point.properties.get('id') : this.objectId;
        if (!window.$isMobile) {
            let defaultImg = this.getOption('iconImageHrefDefault');
            if(!defaultImg) {
                this.setOption('iconImageHrefDefault', this.getOption('iconImageHref'));
            }
            const iconImageHref = state ? '/img/map-point-text-active.svg' : (defaultImg || '/img/map-point-text.svg');
            this.setOption('iconImageHref', iconImageHref);
            if (this.point) {
                //this.pointEl = document.querySelector('.MapOnePoint__point');
                this.pointEl.classList.toggle('MapOnePoint__point--active', state);
            }
            else {
                this.setProperties('classText', state ? 'MapOnePoint__point--active' : '', id);
            }
            this.mapEL.parentElement.classList.toggle('active', state);

            if (state && this.idPointLast !== id) {
                this.idPointLast = id;

                //this.point.properties.set('balloonContent', '')
                //this.setProperties('balloonContent', '');
            }
        }


    }

    fetchObject({ id, url }, cb) {
        fetch(url || this.mapEL.dataset.url + '?id=' + id)
            .then((r) => r.text())
            .then((html) => {
                cb(html);

                const HouseItemEl = document.querySelector('.MapCatalogBlock .HouseItem');
                if (HouseItemEl) {
                    HouseItemInit(HouseItemEl)
                }
            });
    }

    convert(coords) {
        const projection = this.map.options.get('projection');

        return coords.map((el) => {
            const c = projection.fromGlobalPixels(this.map.converter.pageToGlobal([el.x, el.y]), this.map.getZoom());
            return c;
        });
    }

    removePolygon() {
        if (this.polygon) {
            this.polygon.geometry.remove();
        }
    }

    addPolygon(coord) {
        this.polygon = new ymaps.Polygon([coord], {}, {
            fillColor: 'rgba(94,209,188,0.5)',
            strokeColor: '#0E2146',
            opacity: 0.5,
            strokeWidth: 3,
        });

        this.map.geoObjects.add(this.polygon);
    }
}

class CanvasDrawLine {
    constructor(canvasEL, addCb) {
        this.canvas = canvasEL;
        this.addCb = addCb;

        this.configCanvas();

        this.mouseUp = this.mouseUp.bind(this);
        this.mouseDown = this.mouseDown.bind(this);
        this.mouseMove = this.mouseMove.bind(this);

        this.canvas.addEventListener('mousedown', this.mouseDown);
        this.canvas.addEventListener('touchstart', this.mouseDown);
        this.line = [];
    }

    configCanvas() {
        const width = this.canvas.parentElement.clientWidth;
        const height = this.canvas.parentElement.clientHeight;

        this.canvas.width = width * window.devicePixelRatio;
        this.canvas.height = height * window.devicePixelRatio;
        this.canvas.style.width = width + "px";
        this.canvas.style.height = height + "px";

        this.ctx = this.canvas.getContext('2d');
        this.ctx.scale(window.devicePixelRatio, window.devicePixelRatio);

        this.initStyle();
    }

    initStyle() {
        this.ctx.lineWidth = 3;
        this.ctx.strokeStyle = '#0E2146FF';
        this.ctx.lineCap = "round";
    }

    mouseDown(e) {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        this.ctx.beginPath();

        this.canvas.addEventListener('mouseup', this.mouseUp);
        this.canvas.addEventListener('touchend', this.mouseUp);
        this.canvas.addEventListener('touchcancel', this.mouseUp);
        this.canvas.addEventListener('mousemove', this.mouseMove);
        this.canvas.addEventListener('touchmove', this.mouseMove);

        this.ctx.moveTo(e.offsetX, e.offsetY);
        this.line = [{
            x: e.pageX,
            y: e.pageY,
        }];
    }


    mouseMove(e) {
        e.preventDefault();

        this.ctx.lineTo(e.layerX, e.layerY);
        this.ctx.stroke();

        this.line.push({
            x: e.pageX,
            y: e.pageY,
        });
    }

    mouseUp() {
        this.canvas.removeEventListener('mouseup', this.mouseUp);
        this.canvas.removeEventListener('touchend', this.mouseUp);
        this.canvas.removeEventListener('touchcancel', this.mouseUp);
        this.canvas.removeEventListener('mousemove', this.mouseMove);
        this.canvas.removeEventListener('touchmove', this.mouseMove);

        this.aproximate();
    }

    aproximate() {
        this.ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
        const simplyLine = simplify(this.line, 1);

        if (this.addCb) {
            this.addCb(simplyLine);
        }
    }
}

document.querySelectorAll('.MapCatalogBlock').forEach((el) => {
    const btnDraw = el.querySelector('button[data-map-draw]');
    const canvasEl = el.querySelector('.MapCatalogBlock__canvas');
    const modalEl = el.querySelector('.MapCatalogBlock__modal-content');
    const mapEL = el.querySelector('#map');
    const cordsArr = mapEL.dataset.cords && JSON.parse(mapEL.dataset.cords);

    const Map = new PolygonYMap(mapEL, cordsArr, clickToPointMap, getObjectPoint);
    window.MapApp = Map;
    const Canvas = new CanvasDrawLine(canvasEl, (cords) => {
        Map.addPolygon(Map.convert(cords));
        toggleDraw(false);
    })

    btnDraw.addEventListener('click', () => {
        Map.removePolygon();
        toggleDraw();
    });

    function toggleDraw(val) {
        Canvas.configCanvas();
        el.classList.toggle('MapCatalogBlock--draw', val);
    }

    function clickToPointMap(event, object) {
        const id = object.properties.id;

        Map.setProperties('classText', '', Map.idPointLast);
        Map.setProperties('classText', 'MapOnePoint__point--active');

        if (window.$isMobile) {
            Map.fetchObject(object.properties, (html) => {
                modalEl.innerHTML = html;
                const HouseItemEl = document.querySelector('.MapCatalogBlock .HouseItem');
                if (HouseItemEl) {
                    HouseItemInit(HouseItemEl)
                }
            });
            openModal('.MapCatalogBlock__modal');
        }

        el.dispatchEvent(new CustomEvent('map-object', { detail: id }));


    }
});

function getObjectPoint(map) {
    const BalloonContentLayout = ymaps.templateLayoutFactory.createClass('$[properties.balloonContent]', {
        build() {
            BalloonContentLayout.superclass.build.call(this);

            const HouseItemEl = document.querySelector('.MapCatalogBlock .HouseItem');
            if (HouseItemEl) {
                HouseItemInit(HouseItemEl)
            }

            /*const ApartmentItemEl = document.querySelector('.MapCatalogBlock .ApartmentItem');
            if(ApartmentItemEl) {
                ApartmentItemInit(ApartmentItemEl)
            }*/


            if (map.setStatePoint) {
                map.setStatePoint(true);
            }
        },
        clear: function () {
            this.constructor.superclass.clear.call(this);
            if (map.setStatePoint) {
                map.setStatePoint(false);
            }
        },
    });
    const MyBalloonLayout = ymaps.templateLayoutFactory.createClass(
        '<div class="MapPointBalloonEl">$[[options.contentLayout observeSize minWidth=300 maxWidth=300 maxHeight=470]]</div>',
        {
            build: function () {
                this.constructor.superclass.build.call(this);

                const element = document.querySelector('.MapPointBalloonEl');
                element.children[0].style.transform = 'translate(-50%, 20px)';
            },
            getShape: function () {
                const element = document.querySelector('.MapPointBalloonEl');

                if (!element) {
                    return MyBalloonLayout.superclass.getShape.call(this);
                }

                return new ymaps.shape.Rectangle(new ymaps.geometry.pixel.Rectangle([
                    [element.offsetLeft - element.offsetWidth / 2, element.offsetTop], [
                        element.offsetLeft + element.offsetWidth,
                        element.offsetTop + element.offsetHeight,
                    ],
                ]));
            },
        },
    )

    return {
        balloonContent: 'Загрузка...',
        balloonLayout: MyBalloonLayout,
        balloonContentLayout: BalloonContentLayout,
        balloonPanelMaxMapArea: 0,
        hideIconOnBalloonOpen: false,
    };
}

